import { IAffiliateCrudModalLang, AFFILIATE_CRUD_MODAL_LANG_KEY } from './interface.IAffiliateCrudModalLang'
import { IAffiliatePageLang, AFFILIATE_PAGE_LANG_KEY } from './interface.IAffiliatePageLang'
import { IAffiliateListTableLang, AFFILIATE_LIST_TABLE_LANG_KEY } from './interface.IAffiliateListTableLang'

export * from './interface.IAffiliateCrudModalLang'
export * from './interface.IAffiliatePageLang'
export * from './interface.IAffiliateListTableLang'

export type IAffiliateAllLang =
	& IAffiliatePageLang
	& IAffiliateCrudModalLang
	& IAffiliateListTableLang

export const AFFILIATE_ALL_LANG_KEY: IAffiliateAllLang = {
	...AFFILIATE_CRUD_MODAL_LANG_KEY,
	...AFFILIATE_LIST_TABLE_LANG_KEY,
	...AFFILIATE_PAGE_LANG_KEY
}